var _rect, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconRandomizer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.25,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#FEF3F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9998 8.8479C18.4978 8.8479 18.9666 9.04219 19.3187 9.39427L27.3546 17.4301C28.0825 18.158 28.0825 19.3411 27.3546 20.0689L19.3187 28.1048C18.9666 28.4569 18.4978 28.6512 17.9998 28.6512C17.5017 28.6512 17.0329 28.4569 16.6808 28.1048L8.64404 20.0689C7.91616 19.3411 7.91616 18.158 8.64404 17.4301L16.6799 9.39427C17.032 9.04219 17.5008 8.8479 17.9989 8.8479M17.9989 6.75C16.9846 6.75 15.9703 7.13674 15.1959 7.91114L7.16092 15.947C5.61303 17.4949 5.61303 20.0042 7.16092 21.5521L15.1968 29.5879C15.9703 30.3614 16.9855 30.7491 17.9998 30.7491C19.0141 30.7491 20.0284 30.3623 20.8027 29.5879L28.8386 21.5521C30.3865 20.0042 30.3865 17.4949 28.8386 15.947L20.8027 7.91114C20.0293 7.13674 19.0141 6.75 17.9998 6.75H17.9989Z",
    fill: "#F97066"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.453 20.3206C14.3205 20.3206 15.0237 19.6174 15.0237 18.7499C15.0237 17.8824 14.3205 17.1792 13.453 17.1792C12.5855 17.1792 11.8823 17.8824 11.8823 18.7499C11.8823 19.6174 12.5855 20.3206 13.453 20.3206Z",
    fill: "#F97066"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9481 15.7217C18.8156 15.7217 19.5188 15.0185 19.5188 14.151C19.5188 13.2835 18.8156 12.5803 17.9481 12.5803C17.0807 12.5803 16.3774 13.2835 16.3774 14.151C16.3774 15.0185 17.0807 15.7217 17.9481 15.7217Z",
    fill: "#F97066"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9735 24.8931C18.841 24.8931 19.5442 24.1899 19.5442 23.3224C19.5442 22.4549 18.841 21.7517 17.9735 21.7517C17.1061 21.7517 16.4028 22.4549 16.4028 23.3224C16.4028 24.1899 17.1061 24.8931 17.9735 24.8931Z",
    fill: "#F97066"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6244 20.3465C23.4919 20.3465 24.1951 19.6432 24.1951 18.7758C24.1951 17.9083 23.4919 17.2051 22.6244 17.2051C21.7569 17.2051 21.0537 17.9083 21.0537 18.7758C21.0537 19.6432 21.7569 20.3465 22.6244 20.3465Z",
    fill: "#F97066"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRandomizer);
export default __webpack_public_path__ + "static/media/icon-randomizer.93288683c43de7e3a0bd3e40db02c985bfdc4e2d577ab5c735e8d26330a22505.svg";
export { ForwardRef as ReactComponent };